import React from 'react';
import './VehicleTimeline.css';
export default function VehicleTimeline({ vehicles, onVehicleClick }) {
    const months = ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'];
    const currentYear = new Date().getFullYear();

    const getTimelineForVehicle = (v) => {
        const dates = [];
        if (v.next_tuv) dates.push({ label: 'TÜV', d: new Date(v.next_tuv) });
        if (v.next_inspection) dates.push({ label: 'Inspektion', d: new Date(v.next_inspection) });
        if (v.next_tech_check) dates.push({ label: 'UVV', d: new Date(v.next_tech_check) });
        if (v.notification_config?.custom_deadlines) {
            v.notification_config.custom_deadlines.forEach(cd => {
                if (cd.date) dates.push({ label: cd.name || 'Frist', d: new Date(cd.date) });
            });
        }
        const isTruckCheck = (v.category_name || v.vehicle_type || v.internal_name || '').toLowerCase();
        const vehicleIcon = (isTruckCheck.includes('lkw') || isTruckCheck.includes('transporter') || isTruckCheck.includes('truck')) ? '🚛' : '🚗';
        const currentMonthIdx = new Date().getMonth();

        const segments = [];
        for (let i = 0; i < 12; i++) {
            let isRed = false;
            let isOrange = false;
            let currentLabel = '';

            const monthStart = new Date(currentYear, i, 1);

            for (let dd of dates) {
                const yr = dd.d.getFullYear();
                const mo = dd.d.getMonth();

                // Due in this month
                if (yr === currentYear && mo === i) {
                    isRed = true;
                    currentLabel = dd.label;
                    break;
                }
                
                // Past due
                if (dd.d < monthStart) {
                    isRed = true;
                    currentLabel = dd.label + ' (Überfällig)';
                    break;
                }

                // Due next month
                if (yr === currentYear && mo === i + 1) {
                    isOrange = true;
                    if (!currentLabel) currentLabel = dd.label;
                }
                
                // Due next Jan (if we are in Dec)
                if (i === 11 && yr === currentYear + 1 && mo === 0) {
                    isOrange = true;
                    if (!currentLabel) currentLabel = dd.label;
                }
            }

            segments.push({
                color: isRed ? 'red' : (isOrange ? 'orange' : 'green'),
                icon: isRed ? '⚠️' : '',
                label: currentLabel,
                isCurrentMonth: i === currentMonthIdx,
                vehicleIcon: i === currentMonthIdx ? vehicleIcon : null
            });
        }
        return segments;
    };

    return (
        <div className="vehicle-timeline-container">
            <div className="timeline-header">
                <div className="timeline-title">
                    🛣️ Fristen-Highway <span style={{ fontSize: '0.85rem', color: '#64748b', marginLeft: '6px', fontWeight: 500 }}>(Jahresübersicht {currentYear})</span>
                </div>
                <div className="timeline-legend">
                    <div className="legend-item">
                        <div className="legend-color green"></div>
                        <span>OK</span>
                    </div>
                    <div className="legend-item">
                        <div className="legend-color orange"></div>
                        <span>Demnächst</span>
                    </div>
                    <div className="legend-item">
                        <div className="legend-color red"></div>
                        <span>Fällig / Überfällig</span>
                    </div>
                </div>
            </div>
            <div className="timeline-grid-wrapper">
                <div className="timeline-grid">
                    {/* Header Row */}
                    <div className="timeline-grid-header">
                        <div className="timeline-month-label" style={{ textAlign: 'left', paddingLeft: '16px' }}>Fahrzeug</div>
                        {months.map((m, idx) => (
                            <div key={idx} className="timeline-month-label">
                                {idx === 0 ? '🚥 ' : ''}
                                {m}
                                {idx === 11 ? ' 🏁' : ''}
                            </div>
                        ))}
                    </div>

                    {/* Vehicle Rows */}
                    {vehicles.map(v => {
                        const segments = getTimelineForVehicle(v);
                        return (
                            <React.Fragment key={v.id}>
                                <div 
                                    className="timeline-vehicle-cell" 
                                    style={{ cursor: onVehicleClick ? 'pointer' : 'default' }} 
                                    onClick={() => onVehicleClick && onVehicleClick(v)}
                                >
                                    <div className="timeline-vehicle-name" title={v.internal_name} style={{ transition: 'color 0.2s' }} onMouseOver={e => e.currentTarget.style.color = '#3b82f6'} onMouseOut={e => e.currentTarget.style.color = '#0f172a'}>{v.internal_name}</div>
                                    <div className="timeline-vehicle-plate">{v.license_plate}</div>
                                </div>
                                {segments.map((seg, idx) => (
                                    <div key={idx} className="timeline-bar-cell">
                                        <div 
                                            className={`timeline-bar-segment ${seg.color} ${idx === 0 ? 'first-month' : ''} ${idx === 11 ? 'last-month' : ''}`}
                                            style={{ cursor: (seg.icon && onVehicleClick) ? 'pointer' : 'default' }}
                                            onClick={() => { if (seg.icon && onVehicleClick) onVehicleClick(v); }}
                                        >
                                            {seg.isCurrentMonth && <span className="timeline-vehicle-progress-icon" title="Aktueller Monat">{seg.vehicleIcon}</span>}
                                            {seg.icon && <span className="timeline-icon">{seg.icon}</span>}
                                            {seg.label && (
                                                <div className="timeline-tooltip">{seg.label}</div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </React.Fragment>
                        );
                    })}
                    
                    {vehicles.length === 0 && (
                        <div style={{ padding: '20px', textAlign: 'center', gridColumn: '1 / -1', color: '#64748b', fontSize: '0.9rem' }}>
                            Keine Fahrzeuge für die Timeline gefunden.
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
